import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { getAdvice } from '../utils/advice';
import mascot from '../assets/genie-appee.png';
import './GenieCoach.css';

/**
 * Génie coach — LE conseil contextuel de la page courante, calculé depuis les
 * données réelles de l'utilisateur (utils/advice.js). Monté une seule fois dans
 * le Layout → présent sur toutes les pages. Le dismiss est versionné par
 * (conseil + stade) : un conseil de croissance réapparaît après la phase de setup.
 */
export default function GenieCoach() {
  const location = useLocation();
  const navigate = useNavigate();
  const { contacts, campaigns, templates, strategyInstances, companyProfile, smtp, tenant } = useApp();
  const [, force] = useState(0); // re-render après dismiss

  const advice = getAdvice(location.pathname, {
    contacts, campaigns, templates, strategyInstances, companyProfile, smtp, tenant,
  });
  if (!advice) return null;

  const storeKey = `genie_coach_${advice.id}_${advice.stage}`;
  let dismissed = false;
  try { dismissed = localStorage.getItem(storeKey) === '1'; } catch { /* SSR / privé */ }
  if (dismissed) return null;

  const dismiss = () => {
    try { localStorage.setItem(storeKey, '1'); } catch { /* noop */ }
    force(v => v + 1);
  };

  // Le conseil aboutit sur une ACTION déjà construite : on transmet le preset
  // (audience filtrée + message pré-rédigé) au wizard via le state de navigation.
  const go = () => {
    if (!advice.link) return;
    navigate(advice.link, advice.state ? { state: advice.state } : undefined);
  };

  return (
    <div className="genie-coach">
      <img className="genie-coach-avatar" src={mascot} alt="" aria-hidden="true" />
      <div className="genie-coach-body">
        <div className="genie-coach-title">
          <span className="genie-coach-ic" aria-hidden="true">{advice.icon}</span>
          {advice.title}
        </div>
        <div className="genie-coach-text">{advice.text}</div>
        {advice.cta && advice.link && (
          <button type="button" className="genie-coach-cta" onClick={go}>{advice.cta} →</button>
        )}
      </div>
      <button type="button" className="genie-coach-close" onClick={dismiss} aria-label="Compris, masquer ce conseil">Compris&nbsp;✕</button>
    </div>
  );
}
